import React, { useCallback, useEffect, useState } from 'react'
// import NumberFormat from 'react-number-format'
import { Chart } from 'primereact/chart'

import moment from 'moment'
import 'moment/locale/es'
import '../dashboard.css'

import { fetchConToken } from '../../../helpers/fetch'
// import { startOfMonth, endOfMonth } from '../../../helpers/general'

import { DateFilters } from './DateFilters'
import { SectionTotals } from './SectionTotals'

import { ReportByExecutives } from './ReportByExecutives'
import { ReportByAreas } from './ReportByAreas'
import { useDispatch, useSelector } from 'react-redux'
import { dashboardSetFiltersList } from '../../../redux/actions/pptos'

moment.locale('es')

export const DashboardSales = () => {

    const dispatch = useDispatch()
    const info = useSelector(state => state.general.info)
    const filtersDefaultDate = useSelector(state => state.ppto.dashboard_filters)

    const [loadingData, setLoadingData] = useState('')
    const [dataTotals, setDataTotals] = useState(null)
    const [dataAmounts, setDataAmounts] = useState(null)
    const [dataMonthly, setDataMonthly] = useState([])
    const [dataExecutives, setDataExecutives] = useState([])
    const [dataArea, setDataArea] = useState([])

    const [filters, setFilters] = useState({
        time: filtersDefaultDate?.time || 'year',
        dateFrom: filtersDefaultDate?.fecha_desde || new Date(),
        dateTo: filtersDefaultDate?.fecha_hasta || new Date(),
        id_moneda: info.local_id_moneda
    })

    const getData = useCallback(async () => {
        try {
            setLoadingData('Consultando datos...')
            const params = new URLSearchParams(filters).toString()
            const resp = await fetchConToken(`dashboard/sales/?${params}`)
            const res = await resp.json()
            if (res.ok) {
                setLoadingData('Cargando datos...')
                setDataTotals(res.data[0].totals)
                setDataAmounts(res.data[0].amounts)
                setDataMonthly(res.data[0].dataMonthly)
                setDataExecutives(res.data[0].dataExecutives)
                setDataArea(res.data[0].dataArea)
                setLoadingData('')
            }
        } catch (error) {
            console.log(error)
            setLoadingData('')
        }
    }, [filters])

    const handleChangeDate = (newValue) => {
        setFilters({
            ...filters,
            dateFrom: newValue
        })
    }

    useEffect(() => {
        getData()
        dispatch(dashboardSetFiltersList({
            time: filters?.time,
            fecha_desde: filters?.dateFrom,
            fecha_hasta: filters?.dateTo
        }))
    }, [dispatch, filters, getData])

    return (
        <div className='p-container'>
            <h1 className='p-title ml-4 md:ml-0'>Dashboard Ventas</h1>

            <div className='ml-4 md:ml-0'>
                <DateFilters
                    filters={filters}
                    setFilters={setFilters}
                    handleChangeDate={handleChangeDate}
                />
            </div>

            {loadingData === '' ?
                <>
                    <SectionTotals
                        filters={filters}
                        totals={dataTotals}
                        amounts={dataAmounts}
                    />

                    <div className="" style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px' }}>
                        <h5 style={{ fontSize: '15px' }}>Ventas mensuales</h5>
                        <div className="col d-flex justify-content-center">
                            <BarChart data={dataMonthly} color={'#9ae3a1'} />
                        </div>
                    </div>

                    <div className='mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-2'>
                        <ReportByExecutives
                            data={dataExecutives}
                        />
                        <ReportByAreas
                            data={dataArea}
                        />
                    </div>
                </>
                :
                <div className='text-start mt-3'>
                    <div class="spinner-border p-color-primary" role="status">
                        <span class="visually-hidden" style={{ color: 'red' }}>Loading...</span>
                    </div>
                    <div>{loadingData}</div>
                </div>
            }

        </div >
    )
}

const BarChart = ({ data }) => {

    const dataVentas = data

    const chartData = {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            {
                type: 'bar',
                label: 'Ventas',
                backgroundColor: '#b6cfff',
                data: dataVentas,
                borderColor: 'white',
                borderWidth: 2
            }
        ]
    };

    const chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    }

    return (
        <Chart type="line" data={chartData} options={chartOptions} style={{ position: 'relative', width: '100%' }} />
    )

}